import styled from "styled-components";
import { NEAR_WHITE } from "../../../config";

export const Container = styled.div`
  flex-grow: 1;
  height: 100%;
  width: 100%;
  padding-bottom: 10px;
`;

export const TopContainer = styled.div<{ hasMargin: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${({ hasMargin }) => (hasMargin ? "40px" : "38px")};
  margin-bottom: 24px;
`;

export const PageTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  font-size: 1.5rem;
  color: ${NEAR_WHITE};

  div {
    width: calc(48% - 2rem);
  }
`;
